import { render } from "./dashboard-page.vue?vue&type=template&id=c74a987c&scoped=true"
import script from "./dashboard-page.vue?vue&type=script&lang=js"
export * from "./dashboard-page.vue?vue&type=script&lang=js"

import "./dashboard-page.vue?vue&type=style&index=0&id=c74a987c&scoped=true&lang=css"

import exportComponent from "/var/www/tap-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c74a987c"]])

export default __exports__